import { useCallback, useState } from "react";
import { usePortalMenu } from "../../../hooks/usePortalMenu";
import type { RowActionMenuItem } from "./RowActionMenu.types";

export const useRowActionMenuInternalState = (items: ReadonlyArray<RowActionMenuItem>, maxHeight?: number) => {
  const [isOpen, setIsOpen] = useState(false);
  const onClose = useCallback(() => setIsOpen(false), []);
  const onToggle = useCallback(() => setIsOpen((o) => !o), []);
  const { triggerRef, menuRef, rect } = usePortalMenu<HTMLButtonElement, HTMLUListElement>({
    open: isOpen,
    onOutsideClick: onClose,
    maxHeight,
  });
  const onAction = useCallback(
    (id: string) => items.find((i) => i.id === id)?.onSelect(),
    [items],
  );
  return { isOpen, onClose, onToggle, onAction, triggerRef, menuRef, rect };
};
